import { Row, Col } from "react-bootstrap";
import { useStyles } from "./styles";
import { Button } from "@components/Button";
import DataTable from "@components/DataTable";
import { ColumnDef } from "@tanstack/react-table";
import { Product } from "../types";
import { useGetAllProducts } from "./api";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { useNavigate } from "react-router";

const Show = ({ projectId }: { projectId: string }): JSX.Element => {
  const styles = useStyles();
  const navigate = useNavigate();
  const { loading: isLoading, products } = useGetAllProducts({ projectId });

  const productColumns: ColumnDef<Product>[] = [
    {
      header: "Name / Description",
      cell(props) {
        return props.row.original.name;
      },
    },
    {
      header: "Type",
      cell(props) {
        return props.row.original.type;
      },
    },
    {
      header: "MFR Part",
      cell(props) {
        return props.row.original.mfrPartNumber;
      },
    },
    {
      header: "Product Id",
      cell(props) {
        return props.row.original.id;
      },
    },
    {
      header: "qty",
      cell(props) {
        return props.row.original.quantity;
      },
    },
    {
      header: "units",
      cell(props) {
        return props.row.original.units;
      },
    },
    {
      header: "unit price",
      cell(props) {
        return props.row.original.price;
      },
    },
  ];

  return (
    <div>
      <Row>
        <Col>
          {isLoading ? (
            <ScopeStackSpinner />
          ) : (
            <div className={styles.card}>
              <div className={styles.cardHeader}>
                <h2>Products</h2>
                <div className={styles.actionButtons}>
                  <Button onClick={() => navigate("custom")}>Add Custom</Button>
                  <Button onClick={() => navigate("new")}>Add Products</Button>
                </div>
              </div>
              <hr></hr>
              <DataTable
                data={products}
                columns={productColumns}
                selectable={true}
              />
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Show;
